module.exports = __webpack_public_path__ + "img/notes.2bba57d3.svg";